import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmlToPlaintext'
})
export class HtmlToPlaintextPipe implements PipeTransform {
    transform(value: any): string {
        if (!value) return ''; // Return empty string for null/undefined values

        // Remove all <style> tags and their content using a regular expression
        const withoutStyleTags = value.replace(/<style[^>]*>.*?<\/style>/gs, '');

        // Create a temporary DOM element
        const tempElement = document.createElement('div');
        tempElement.innerHTML = withoutStyleTags; // Set the HTML content

        // Extract plain text (removes all tags, attributes, and styles)
        return tempElement.textContent || '';
    }
}